<template>
  <div class="plan-card border p-sm">
    <p
      v-if="!plan.shipmentsPerInterval"
      class="best-value small-text fw-bold">
      {{ homepagePlanCardBestValueText }}
    </p>
    <div class="plan-card-inner">
      <h2
        class="line-decorator"
        v-html="parsePlanOnNextLine(plan.displayName)"/>
      <p class="fw-semibold color-plum my-sm">
        <span
          v-if="hasPromo">
          <b>{{ formatPrice(plan.contextualPricing.price, true) }} first month</b> ({{ formattedBasePrice }}/month after)
        </span>
        <span v-else>
          <b>{{ formattedBasePrice }} per month</b>
        </span>
      </p>
      <span
        class="mb-md">
        <p>Rent {{ plan.nItems }} item{{ plan.nItems > 1 ? 's' : '' }} at a time.</p>
        <p v-if="plan.shipmentsPerInterval">Swap every 30 days.</p>
        <p v-else>
          <b>Unlimited</b> Swaps.
        </p>
      </span>
      <TrackingButton
        :text="`Try ${plan.displayName}`"
        app-entry-point="homepage"
        class="w-100"
        :to="signupUrl"
        :event-label="`Plan Card - ${plan.name}`"/>
    </div>
  </div>
</template>
<script setup>
import { ref } from 'vue'
import TrackingButton from '@shared/components/ADORN/TrackingButton.vue'
import { useGenericContentStore } from '@shared/stores/genericContent.js'
import { storeToRefs } from 'pinia'
import { parsePlanOnNextLine } from '@shared/utils/plans.js'
import { formatPrice } from '@/utils/stringParsing.js'
import { computed, inject } from 'vue'

const props = defineProps({
  plan: {
    type: Object,
    required: true
  }
})

const genericContentStore = useGenericContentStore()
const { homepagePlanCardSection } = storeToRefs(genericContentStore)
const homepagePlanCardBestValueText = computed(() => homepagePlanCardSection?.value?.blocks?.[0]?.text || 'Best Value')
const referralCode = inject('referralCode', '')

const baseSignupUrl = ref('/signup/intro/?plan=')
const signupUrl = computed(() =>
  referralCode
    ? `${baseSignupUrl.value}${props.plan.id}&r=${referralCode.value}`
    : `${baseSignupUrl.value}${props.plan.id}`
)

const hasPromo = computed(() => {
  return !!props.plan.defaultPromo
})

const formattedBasePrice = computed(() => {
  return formatPrice(props.plan.basePrice, true)
})

</script>
<style scoped lang="scss">
.plan-card {
  aspect-ratio: 8/7;
  height: fit-content;
  max-width: fit-content;
  min-width: 350px;
  background-color: $white;
}
.best-value {
  background-color: $champagne;
  color: $plum;
  padding: $spacing-xxs $spacing-xxl;
  width: fit-content ;
  position: relative;
  top: 18px;
  margin: -30px auto 0 auto;
}
.plan-card-inner {
  border: $spacing-xs solid $champagne;
  display: flex;
  flex-direction: column;
  padding: 0 $spacing-sm;
  align-items: center;
  justify-content: center;
  height: 100%;
}
.line-decorator {
  display: flex;
  width: 100%;
  white-space: nowrap;
  gap: $spacing-md;
  &::before {
    content: '';
    display: block;
    background-color: $ash;
    width: 100%;
    height: 1px;
    position: relative;
    top: 30px;
  }
  &::after{
    content: '';
    display: block;
    background-color: $ash;
    width: 100%;
    height: 1px;
    position: relative;
    top: 30px;
  }
}
</style>
